import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTurkey = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1014)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.5087 9.8056L12.4933 11.1624L14.0878 10.6454L13.1017 12.001L14.0861 13.3577L12.4921 12.8387L11.506 14.1944L11.5071 12.5181L9.91302 11.9991L11.5076 11.482L11.5087 9.8056Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.82159 15.3913C6.94865 15.3913 5.43028 13.8729 5.43028 12C5.43028 10.1271 6.94865 8.60869 8.82159 8.60869C9.40556 8.60869 9.95503 8.75639 10.4347 9.01632C9.68217 8.28028 8.65293 7.82607 7.51724 7.82607C5.21203 7.82607 3.34335 9.69478 3.34335 12C3.34335 14.3051 5.21207 16.1738 7.51724 16.1738C8.65303 16.1738 9.68221 15.7196 10.4347 14.9836C9.95503 15.2436 9.40556 15.3913 8.82159 15.3913Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1014",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgTurkey;
